import callCmAPI from 'services/helpers/call-cm-api'

export const deleteUser = (userId) =>
  callCmAPI(`/user/${userId}`, {
    method: 'delete',
  })
    .then((res) => res.data)
    .catch((err) => err)
